import { render, staticRenderFns } from "./ConnectWallet.vue?vue&type=template&id=a9b63670&scoped=true&"
import script from "./ConnectWallet.vue?vue&type=script&lang=js&"
export * from "./ConnectWallet.vue?vue&type=script&lang=js&"
import style0 from "./ConnectWallet.vue?vue&type=style&index=0&id=a9b63670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b63670",
  null
  
)

export default component.exports